import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TenantService } from '@cloudia-shared/tenant/tenant.service';
import { environment } from '@envs/environment';
import { Observable, tap } from 'rxjs';
import { CLOUDIA_SERVICES } from '@cloudia-internal/src/app/core/interceptors/claudia-services';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class LocalBackendHttpInterceptor implements HttpInterceptor {
  constructor(
    private tenantService: TenantService,
    private readonly toastrService: ToastrService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const secureReq = req.clone({
      url: this.getLocalUrlForBackend(req.url),
    });

    return next.handle(secureReq).pipe(
      tap(
        () => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 401) {
              return;
            }
            if (!location.href.includes('csat/evaluation')) {
              this.toastrService
                .warning('Tap to login again', 'Session expired')
                .onTap.subscribe((value) => {
                  location.reload();
                });
            }
          }
        }
      )
    );
  }

  private getLocalUrlForBackend(originUrl: string): string {
    const apiUrl = environment.apiUrl;
    let localUrl = '';

    Object.entries(CLOUDIA_SERVICES).forEach(([name, body]) => {
      const found = body.endpoints.find(
        (endpointName) =>
          originUrl.includes(`/api${endpointName}`) &&
          !originUrl.includes(body.basePath)
      );

      if (found) {
        localUrl = originUrl.replace(
          apiUrl,
          `http://localhost:${body.port}/${body.basePath}/api/`
        );
      }
    });

    return localUrl;
  }
}
